"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const DatePickers_1 = require("../DatePickers");
const utilities_1 = require("../utilities");
const polished_1 = require("polished");
const Icon_1 = tslib_1.__importDefault(require("../Icon"));
const Input_1 = tslib_1.__importDefault(require("../Input"));
const Segment_1 = tslib_1.__importDefault(require("../Segment"));
const Header_1 = tslib_1.__importDefault(require("../Segment/Header"));
const select_1 = tslib_1.__importDefault(require("./filters/select"));
const Sidebar_1 = tslib_1.__importDefault(require("../Sidebar"));
const SmarttagControl_1 = tslib_1.__importDefault(require("../SmarttagsControl/SmarttagControl"));
const styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
const WrapperInput = (0, styled_components_1.default)('div') `
  position: relative;
  width: 100%;
  border-left: none;
  justify-content: center;
  * {
    border-radius: 0 !important;
    border-top: 0 !important;
    border-right: 0 !important;
    border-left: 0 !important;
  }
  .input-icon {
    background-color: #fff;
  }
`;
const WrapperWoInput = (0, styled_components_1.default)(WrapperInput) `
  padding-top: ${(0, polished_1.rem)(6)};
  border-bottom: ${(0, polished_1.rem)(1)} solid ${({ theme }) => theme.separatorColor};
  padding-left: ${({ theme }) => (0, polished_1.rem)(theme.input.horizontalPadding)};
  cursor: pointer;
  background-color: #fff;
`;
const WrapperIcon = (0, styled_components_1.default)('div') `
  position: absolute;
  min-width: ${(0, polished_1.rem)(32)};
  width: ${(0, polished_1.rem)(40)};
  top: 0;
  bottom: 0;
  right: 0;
  border-left: none;
  justify-content: center;
`;
const WrapperCountFilter = (0, styled_components_1.default)('div') `
  background: red;
  border-radius: ${(0, polished_1.rem)(4)} !important;
  color: #fff;
  position: absolute;
  top: ${(0, polished_1.rem)(-3)};
  left: ${(0, polished_1.rem)(21)};
  font-size: ${(0, polished_1.rem)(10)};
  font-weight: bold;
  line-height: ${(0, polished_1.rem)(19)};
  text-align: center;
  white-space: nowrap;
  padding: 0 ${(0, polished_1.rem)(5)};
  min-width: ${(0, polished_1.rem)(17)};
  z-index: 1;
`;
const StyledInput = (0, styled_components_1.default)(Input_1.default) `
  width: 100%;
  height: ${(0, polished_1.rem)(40)};
  &::placeholder {
    color: ${({ theme }) => theme.inactiveColor};
  }
  color: ${({ theme }) => theme.textColor};
  box-shadow: none;
`;
const WrapperButton = (0, styled_components_1.default)('div') `
  height: ${(0, polished_1.rem)(48)};
  width: 100%;
  padding: ${(0, polished_1.rem)(14)};
  color: red;
  font-size: ${(0, polished_1.rem)(16)};
  cursor: pointer;
  text-align: center;
  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      color: #e0e0eb;
      cursor: not-allowed;
    `}
`;
const IconButton = (0, styled_components_1.default)('button') `
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  border: none;
  background: #fff;
  cursor: pointer;
  width: ${(0, polished_1.rem)(32)};
  z-index: 0;
  margin: 0;
  padding: 0;
`;
exports.default = (0, styled_components_1.withTheme)((props) => {
    const { onChange, value, filters } = props;
    const [sidebarOpened, setSidebarOpened] = React.useState(false);
    let queryFilterName = '';
    let queryFilter = null;
    const sidebarFilters = [];
    for (const f of filters) {
        if (f.type === 'query') {
            queryFilter = f;
            queryFilterName = f.name;
        }
        else {
            sidebarFilters.push(f);
        }
    }
    const countFilter = () => {
        let totalCountFilter = 0;
        for (const valueName of Object.keys(value)) {
            if (valueName === queryFilterName) {
                continue;
            }
            const f = value[valueName];
            if (typeof f === 'undefined') {
                continue;
            }
            if (Array.isArray(f)) {
                if (f.length > 0) {
                    totalCountFilter++;
                }
            }
            else {
                if (f === null) {
                }
                else if (typeof f === 'string') {
                    if (f.length === 0) {
                    }
                    else {
                        totalCountFilter++;
                    }
                }
                else if (f.value === '' || f.value === null) {
                }
                else {
                    totalCountFilter++;
                }
            }
        }
        return totalCountFilter;
    };
    const deleteAllSelect = () => {
        if (queryFilter) {
            const nextValue = { [queryFilter.name]: value[queryFilter.name] };
            onChange(nextValue);
        }
        else {
            onChange({});
        }
    };
    const handleSearch = (e) => {
        if (queryFilter) {
            if (queryFilter && e.target.value) {
                const nextValue = Object.assign(Object.assign({}, value), { [queryFilter.name]: e.target.value });
                onChange(nextValue);
            }
            else {
                delete value[queryFilter.name];
                const nextValue = Object.assign({}, value);
                onChange(nextValue);
            }
        }
    };
    function createSidebarButton() {
        return (React.createElement(WrapperIcon, null,
            React.createElement(IconButton, { onClick: () => {
                    setSidebarOpened(!sidebarOpened);
                }, "data-testid": "UI_Filter_Button_Tune" },
                countOfFilter !== 0 && (React.createElement(WrapperCountFilter, null, countOfFilter)),
                React.createElement(Icon_1.default, { name: "tune", size: iconSize, color: countOfFilter !== 0
                        ? props.theme.color.primary
                        : sidebarOpened
                            ? props.theme.textColor
                            : props.theme.inactiveColor }))));
    }
    function createHeadSegment(filter) {
        return (React.createElement(Header_1.default, Object.assign({ size: "xs" }, filter), filter.label));
    }
    const countOfFilter = countFilter();
    const iconSize = 30;
    function renderFilters() {
        if (!sidebarFilters) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            sidebarFilters.map((filter, idx) => {
                if (filter.type === 'select') {
                    return (React.createElement(Segment_1.default, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(select_1.default, { filter: filter, value: value[filter.name], onChange: v => {
                                onChange(Object.assign(Object.assign({}, value), { [filter.name]: v }));
                            } })));
                }
                else if (filter.type === 'smarttag') {
                    return (React.createElement(Segment_1.default, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(SmarttagControl_1.default, Object.assign({}, filter, { availableSmarttags: filter.availableSmarttags || [], value: value[filter.name], creatable: false, onChange: (v) => {
                                onChange(Object.assign(Object.assign({}, value), { [filter.name]: v }));
                            } }))));
                }
                else if (filter.type === 'date') {
                    return (React.createElement(Segment_1.default, { noBottomGutter: true, key: `filter-${filter.type}-${filter.name}-${idx}` },
                        createHeadSegment(filter),
                        React.createElement(DatePickers_1.DatePicker, Object.assign({}, filter, { value: value[filter.name]
                                ? new Date(String(value[filter.name]))
                                : null, onChange: (v) => {
                                onChange(Object.assign(Object.assign({}, value), { [filter.name]: v }));
                            } }))));
                }
                return null;
            }),
            React.createElement(WrapperButton, { onClick: deleteAllSelect, "$disabled": countOfFilter === 0 }, (0, utilities_1.__)('Odstrániť filtre'))));
    }
    const inputTheme = React.useMemo(() => {
        return Object.assign(Object.assign({}, props.theme), { input: Object.assign(Object.assign({}, props.theme.input), { borderColor: props.theme.separatorColor }) });
    }, [props.theme]);
    return (React.createElement(React.Fragment, null,
        queryFilter ? (React.createElement(WrapperInput, null,
            React.createElement(styled_components_1.ThemeProvider, { theme: inputTheme },
                React.createElement(StyledInput, Object.assign({}, queryFilter, { type: "text", value: value[queryFilter.name], onChange: handleSearch }),
                    React.createElement(Input_1.default.Icon, { className: "input-icon", name: "search", size: iconSize, color: "#000" }),
                    React.createElement("input", null))),
            sidebarFilters.length > 0 && createSidebarButton())) : (React.createElement(WrapperWoInput, { onClick: () => {
                setSidebarOpened(!sidebarOpened);
            } },
            React.createElement(Icon_1.default, { name: "search", size: iconSize, color: "#000" }),
            createSidebarButton())),
        React.createElement(Sidebar_1.default, { header: (0, utilities_1.__)('Aktívny filter'), visible: sidebarOpened, onClose: () => {
                setSidebarOpened(false);
            } }, renderFilters())));
});
